import React, { useEffect, useState } from 'react';
import BookPreview from '../BookPreview';
import { bizApi } from '../../lib/business';
import useBusiness from './useBusiness';

// The same booking page as /book, in business mode: pick a saved traveler (or add one) and the ride goes on the company account.
export default function BusinessBook() {
  const { loading, company } = useBusiness();
  const [travelers, setTravelers] = useState(null);
  useEffect(() => { if (company) bizApi('/business/travelers').then((r) => setTravelers(r.travelers || [])).catch(() => setTravelers([])); }, [company]);
  if (loading || !company || travelers === null) return <div className="min-h-screen bg-[#0d0e11] text-gray-300 flex items-center justify-center" role="status">Loading…</div>;
  return <BookPreview business={{ company, travelers }} />;
}
